import type { Role } from '../types'

/** localStorage-Schlüssel (Editor-Namespace). */
export const STORAGE_KEYS = {
  theme: 'vcard.editor.theme',
  jwt: 'vcard.editor.jwt',
  trustedDevice: 'vcard.editor.trustedDevice',
} as const

/** Rollen-Startseite nach Login (TP2 §D5): admin/brand-admin → Konsole,
 *  user → eigener vCard-Editor. */
export function roleStartPath(role: Role): string {
  return role === 'user' ? '/editor/me' : '/admin/dashboard'
}
